import React, { FocusEventHandler } from 'react';
import clsx from 'clsx';
import Button from '@components/Button';

import useScreen, { Screen } from '@hooks/useScreen';

export interface WalletAddressInputProps {
  className?: string;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onConnectSecondWallet: (e: React.MouseEvent<HTMLButtonElement>) => void;
  value: string;
}

const WalletAddressInput = ({
  className,
  onBlur,
  onChange,
  onConnectSecondWallet,
  value,
}: WalletAddressInputProps) => {
  const { screen } = useScreen();

  return (
    <div
      className={clsx(
        'flex bg-black items-center p-2 rounded-small shadow-default',
        className
      )}
    >
      <input
        data-testid="wallet-address-input"
        className="outline-none bg-transparent border-none caret-white text-white text-smallSemibold font-semibold flex-1 placeholder-white"
        onBlur={onBlur}
        onChange={onChange}
        placeholder="Destination"
        spellCheck="false"
        type="text"
        value={value}
      />
      {screen && screen >= Screen.desktop && (
        <>
          {value === '' && (
            <div
              className="text-white text-smallSemibold font-semibold px-3"
              data-testid="wallet-address-input-or-text"
            >
              or
            </div>
          )}
          <Button
            size="micro"
            variant="inverted"
            onClick={onConnectSecondWallet}
            data-testid="connect-second-wallet-button"
          >
            Connect Second Wallet
          </Button>
        </>
      )}
    </div>
  );
};

export default WalletAddressInput;
